<template>
	<div class="card darken-3">
		<ul class="card-content collection with-header">
			<li class="collection-header teal-text center-align">
				<h3>Current To-Do list</h3>
			</li>
			<div v-if="loggedIn">
				<li v-for="(item, index) in list" :key="index" class="collection-item">
					<span>{{ item }}</span>
					<a @click.prevent="del(index)" class="secondary-content">
						<i class="material-icons red-text text-darken-3">delete</i>
					</a>

					<a @click.prevent="edit(index)" class="secondary-content">
						<i class="material-icons blue-text text-darken-3">edit</i>
					</a>
				</li>
			</div>

			<div v-else>
				<li class="collection-item">
					<h5 class="red-text center-align">Please log in to edit your list!</h5>
				</li>
			</div>

			<li class="center-align">
				<button
					v-if="loggedIn"
					data-target="addItemModal"
					class="add-item waves-effect waves-light btn modal-trigger"
				>Add Item</button>

				<div id="addItemModal" class="modal">
					<div class="modal-content">
						<h4 class="teal-text">Add Item</h4>
						<form @submit.prevent="add" class="col s12">
							<div class="input-field col s6">
								<input type="text" id="newItem" v-model="newItem" />
								<label for="newItem">Add a new item</label>
							</div>
							<div class="modal-footer">
								<a class="modal-close waves-effect waves-green btn">Close</a>
								<button class="modal-close waves-effect waves-green btn" @click.prevent="add">Agree</button>
							</div>
						</form>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
import firebase from 'firebase'
import db from '@/firebase/init'

export default {
	name: "List",
	data() {
		return {
			list: [],
			loggedIn: false,
			userId: null,
			username: null,
			newItem: null
		}
	},
	methods: {
		pushToDb() {
			firebase.auth().onAuthStateChanged(user => {
				if (user) {
					db.collection("users").doc(this.userId).set({
						todos: this.list,
						user_uid: user.uid,
						username: this.username
					})
				}
			})
		},
		add() {
			this.list.push(this.newItem.charAt(0).toUpperCase() + this.newItem.slice(1))
			this.newItem = null
			this.pushToDb()
		},
		del(index) {
			this.list.splice(index, 1)
			this.pushToDb()
		}
	},
	created() {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.loggedIn = true

				db.collection("users").get()
					.then(snapshot => {
						snapshot.forEach(doc => {
							if (doc.data().user_uid == user.uid) {
								this.username = doc.data().username
								this.list = doc.data().todos
								this.userId = doc.id
							}
						})

					})
					.catch(err => console.error(err))
			}
		})
	}
}
</script>
<style>
.secondary-content {
	margin-left: 10px;
}

.add-item {
	margin-top: 20px;
}

a.secondary-content {
	cursor: pointer;
}

.modal {
	max-width: 600px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/List.vue